import * as yup from "yup";

export const myProfileFormSchema = yup.object({
  firstName: yup.string().required("Името е задължително"),
  lastName: yup.string().default(""),
  phoneNumber: yup.string().default(""),
  email: yup.string().email("Невалиден имейл").default(""),
  birthDate: yup.date().nullable().default(null),
  fontSizePercent: yup
    .number()
    .min(80, "Минималният размер на шрифта е 80%")
    .max(140, "Максималният размер на шрифта е 140%")
    .default(100),
});

export type IMyProfileFormModel = yup.InferType<typeof myProfileFormSchema>;

export const myProfileFormDefaultValues: IMyProfileFormModel = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  birthDate: null,
  fontSizePercent: 100,
};
